export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/operationLog/queryOperationLog`,
          data
        });
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      removeOperationLog(data) {
          return http.json({
              url: `/operationLog/deleteByIdOperationLog?id=${data[0].id}`,
              data
          })
      },
      list (data){
          return http.json({
              url: '/operationLog/list',
              data
          })
      },
      exportList (data){
          return http.json({
              url: '/operationLog/exportList',
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/operationLog.js